export const formSchema = {
  title: "",
  topics:[],
  due_date: "",
  epilogue_title: "",
  epilogue_outro_note: "",
  easy:null,
  medium:null,
  hard:null
};
export const questionSchema = {
  question: "",
  time_to_answer: null,
  rank:1,
  skills: [],
};



